module.exports = __webpack_public_path__ + "img/system50-details.532212d8.png";